export default "__VITE_ASSET__z_Xe3Y1W__"